/* eslint-disable */
export default {
    questionnairebuilder_page_title: "Questionnaire builder",
    questionnairebuilder_load_error: "Er ging iets mis tijdens het laden van de content",
    questionnairebuilder_en_GB: "Engels",
    questionnairebuilder_nl_NL: "Nederlands",
    questionnairebuilder_unsaved_changes: "Er zijn niet opgeslagen wijzigingen",
    questionnairebuilder_all_changes_saved: "Alle wijzigingen zijn opgeslagen",
    questionnairebuilder_save_button: "Opslaan",
    questionnairebuilder_save_error: "Er ging iets mis bij het opslaan",
    questionnairebuilder_section_title_question: "Vraagstelling",
    questionnairebuilder_section_title_choices: "Antwoordopties",
    questionnairebuilder_section_title_feedback: "Feedback",
    questionnairebuilder_key_used_in: "Deze vertaling wordt gebruikt in",
    questionnairebuilder_de_DE: "Duits",
    questionnairebuilder_fr_FR: "Frans"
};
